"use client";

import { createTheme, ThemeOptions } from "@mui/material/styles";

const baseTheme: ThemeOptions = {
  cssVariables: true,

  typography: {
    fontFamily: `var(--font-roboto), 'Inter', 'Helvetica', 'Arial', sans-serif`,
    h1: { fontSize: "2.25rem", fontWeight: 700, lineHeight: 1.2 },
    h2: { fontSize: "1.875rem", fontWeight: 600, lineHeight: 1.25 },
    h3: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: "1rem", lineHeight: 1.6 },
    body2: { fontSize: "0.875rem", lineHeight: 1.5 },
    button: { fontWeight: 600, textTransform: "none" },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active":
            {
              WebkitBoxShadow: "0 0 0 1000px var(--mui-palette-background-paper) inset !important",
              WebkitTextFillColor: "var(--mui-palette-text-primary) !important",
              caretColor: "var(--mui-palette-text-primary)",
              borderRadius: "inherit",
              transition: "background-color 9999s ease-in-out 0s",
            },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 12,
          border: "1px solid",
          borderColor: theme.palette.divider,
          boxShadow: "none",
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        }),
      },
    },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "light",

    primary: {
      light: "#A7D0C9",
      main: "#3F7B74",
      dark: "#33625c",
      contrastText: "#FFFFFF",
    },

    secondary: {
      light: "#BFD7EA",
      main: "#7BA4C7",
      dark: "#456B92",
      contrastText: "#FFFFFF",
    },

    background: {
      default: "#F7F5F2",
      paper: "#FFFFFF",
    },

    text: {
      primary: "#1A1A1A",
      secondary: "#5C5853",
      disabled: "#A0A0A0",
    },

    divider: "#E5E7EB",
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "dark",

    primary: {
      light: "#7CC7BD",
      main: "#4E8F87",
      dark: "#2B5B55",
      contrastText: "#FFFFFF",
    },

    secondary: {
      light: "#9BBAD5",
      main: "#6E92B8",
      dark: "#344E6E",
      contrastText: "#FFFFFF",
    },

    background: {
      default: "#0D1113",
      paper: "#161A1D",
    },

    text: {
      primary: "#FFFFFF",
      secondary: "#B8C2C7",
      disabled: "#6B7280",
    },

    divider: "#161A1D",
  },
});
